<template>
	<b-card>
		<template #header>
			<span style="font-size: 20px; font-weight: bold">Тип контрагента</span>
			<b-input-group class="float-right shadow" style="width: 250px">
				<template #prepend>
					<b-button class="fa fa-search"/>
				</template>
				<b-form-input v-model="search" placeholder="Поиск"/>
				<template #append>
					<b-button @click="create=true;form={};createOrEditModal=true" variant="outline-primary" class="fa fa-plus"/>
				</template>
			</b-input-group>
		</template>
		<b-overlay :show="loading" rounded="sm">
			<b-table :items="items" :fields="fields" hover bordered striped :busy="loading" show-empty>
				<template slot="empty" slot-scope="scope">
					<h4 class="text-center">{{ $t('empty') }}</h4>
				</template>
				<template slot="index" slot-scope="data">
					<strong>{{data.index+1}}</strong>
				</template>
				<template slot="actions" slot-scope="data">
					<b-badge variant="dark" class="p-1 mr-3" style="font-size: 14px; cursor: pointer" @click="editForm(data.item)">
						<i class="fa fa-edit"></i>
					</b-badge>
					<b-badge variant="danger" class="p-1" style="font-size: 14px; cursor: pointer" @click="onOpen(data.item.id)">
						<b-link style="color: white" :key="data.item.id + 'delete'" :id="'popOverDelete'+data.item.id">
							<i class="fa fa-trash"></i>
						</b-link>
					</b-badge>
					<!-- POPOVER TO CONFIRM DELETING THE REFERENCE -->
					<b-popover :key="data.item.id + 'popover'" :target="'popOverDelete'+data.item.id" placement="auto" container="myContainer" :ref="'popover'+data.item.id" class="refDeleteConfirm">
						<template slot="title">
							<b-button @click="onClose(data.item.id)" class="close" aria-label="Close" style="margin-left: 5px">
								<span class="d-inline-block" aria-hidden="true">&times;</span>
							</b-button>
							{{$t('actions.deletetitle')}}
						</template>
						<div>
							<div class="row mt-1">
								<div class="col-6">
									<b-button variant="outline-danger" size="sm" block @click="onClose(data.item.id)">{{$t('actions.no')}}</b-button>
								</div>
								<div class="col-6">
									<b-button variant="outline-success" size="sm" block @click="deleteContract(data.item.id)">{{$t('actions.yes')}}</b-button>
								</div>
							</div>
						</div>
					</b-popover>
				</template>
			</b-table>
		</b-overlay>

		<!--      Create Or Edit Doc      -->
		<b-modal v-model="createOrEditModal" :title="create ? `Создать` : `Редактировать`" hide-footer :busy="loading" no-close-on-backdrop no-close-on-esc>
			<b-overlay :show="loading" rounded="sm">
				<b-row>
					<b-col>
						<b-input-group>
							<template #prepend>
								<b-button disabled>{{ $t('goods.create.name') }}</b-button>
							</template>
							<b-form-input v-model="form.name"/>
						</b-input-group>
					</b-col>
				</b-row>
				<b-row class="mt-3">
					<b-col>
						<b-input-group>
							<template #prepend>
								<b-button disabled>{{ $t('reference.code') }}</b-button>
							</template>
							<b-form-input v-model="form.code"/>
						</b-input-group>
					</b-col>
				</b-row>
				<hr>
				<b-row>
					<b-col align="right">
						<b-button @click="createOrEditModal=false" variant="outline-danger" class="mr-2">Отменить</b-button>
						<b-button @click="save" variant="success" class="mr-2">Сохранить</b-button>
					</b-col>
				</b-row>
			</b-overlay>
		</b-modal>
	</b-card>
</template>

<script>
import ContractService from "./contract.service";
import {BOverlay} from 'bootstrapVue2';

export default {
	name: "stage",
	components: {BOverlay},
	data() {
		return {
			loading: false,
			search: '',
			createOrEditModal: false,
			create: true,
			form: {
				name: '',
				code: ''
			},
			items: [],
			fields: [
				{key: 'index', label: '№', class: 'text-center'},
				{key: 'name', label: this.$t("goods.create.name"), class: 'text-center',sortable: true},
				{key: 'code', label: this.$t('reference.code'), class: 'text-center',sortable: true},
				{key: 'actions', label: this.$t('goods.actions'), class: 'text-center'}
			]
		}
	},
	watch: {
		'search': {
			handler(s) {
				this.getList();
			}
		}
	},
	methods: {
		/* POPOVER METHODS BEGIN */
		onOpen (itemId) {
			let refName = 'popover' + itemId;
			this.$refs[refName].$emit('open')
		},
		onClose (itemId) {
			let refName = 'popover' + itemId;
			this.$refs[refName].$emit('close')
		},
		getList() {
			this.loading = true
			ContractService.getContractStage(this.search).then(res => {
				this.items = res.data
				this.loading = false
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		editForm(item) {
			this.form = Object.assign({}, item)
			this.create = false
			this.createOrEditModal = true
		},
		save() {
			if (this.form.name !== '' && this.form.code !== '') {
				this.loading = true
				if (this.create) {
					ContractService.createContractStage(this.form).then(res => {
						this.getList();
						this.createOrEditModal = false
						this.loading = false
					}).catch(e => {
						this.loading = false
						this.$vs.notify({
							title: e.message,
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						});
					})
				} else {
					ContractService.updateContractStage(this.form).then(res => {
						this.getList();
						this.createOrEditModal = false
						this.loading = false
					}).catch(e => {
						this.loading = false
						this.$vs.notify({
							title: e.message,
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						});
					})
				}
			} else {
				this.$vs.notify({
					title: this.$t('required_error'),
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			}
		},
		deleteContract(id) {
			this.loading = true
			ContractService.deleteContractStage(id).then(res => {
				this.getList();
				this.loading = false
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		}
	},
	created() {
		this.getList();
	}
}
</script>

<style scoped>

</style>
